import { Injectable } from '@angular/core';
import { TCSettingsService } from '@cloud-twin-v2/cloud-twin-shared/core/tc-settings.service';
//prettier-ignore
import * as L from 'leaflet';
//prettier-ignore
import { HttpClient } from '@angular/common/http';
import 'leaflet-wfst';
import { LayerInfo, LayerItem, LayerStyle, LayerTypeEnum } from '../models/layer-item';
export const Leaflet = L;

@Injectable()
export class LayerService {
  constructor(private _tcSettingsService: TCSettingsService, private _httpClient: HttpClient) {}

  getNodeLayer(namespace: string, layerName: string) {
    const geoJsonObj = new Leaflet.Format.GeoJSON({
      crs: Leaflet.CRS.EPSG3857,
      pointToLayer(geoJsonPoint, latlng) {
        const layer = new Leaflet.circleMarker(latlng, {
          radius: 5,
          pane: 'node',
        });
        return layer;
      },
    });

    const nodeLayer = new LayerItem({
      name: 'node',
      pane: 'node',
      layerStyles: new LayerStyle({ zIndex: 5 }),
      nativeLayer: new Leaflet.WFS(
        {
          url: 'https://map.platform.simulator.wlm.one/geoserver/test/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=test%3Atest-layer-view&outputFormat=application%2Fjson&CQL_FILTER=step=%272023-12-14T23:00:00Z%27',
          //typeNS: namespace,
          //typeName: 'test:test-layer-view', //layerName,
          crs: Leaflet.CRS.EPSG3857,
          //geometryField: 'geometry',
        },
        geoJsonObj
      ),
    });

    return nodeLayer;
  }

  getLineLayer(namespace: string, layerName: string) {
    const lineLayer = new LayerItem({
      name: 'pipeLayer',
      pane: 'pipes',
      layerStyles: new LayerStyle({ zIndex: 4 }),
      nativeLayer: Leaflet.wfs(
        {
          url: `https://map.platform.simulator.wlm.one/geoserver/wlm/ows`,
          typeNS: 'wlm',
          typeName: 'test-topography',
          crs: Leaflet.CRS.EPSG3857,
          geometryField: 'geometry',
          filter: new Leaflet.Filter.And(
            new Leaflet.Filter.EQ('neType', 'Node'),
            new Leaflet.Filter.EQ('snapshotId', '0195fb2b-a8a9-47df-8c9d-f9cc54b192d1'),
            new Leaflet.Filter.Or(
              new Leaflet.Filter.EQ('neId', '0195fb31-8c76-4752-a1af-b9aaaf08f5e1'),
              new Leaflet.Filter.EQ('neId', '0195fb3a-3a68-4b7d-9b4e-1fe3a3150486')
            )
          ).toGml(),
        },
        new Leaflet.Format.GeoJSON({
          crs: Leaflet.CRS.EPSG3857,
          pane: 'pipes',
          pointToLayer: (feature, latLng) => {
            const newStyles = this.getTestDynamicStyles(feature);
            return Leaflet.circleMarker(latLng, newStyles);
          },
          //style: (feature) => this.getTestDynamicStyles(feature)
        })
      ),
      getDynamicStyles: this.getTestDynamicStyles,
    });

    return lineLayer;
  }

  private getTestDynamicStyles = (feature) => {
    const properties = feature?.properties;
    if (!properties) {
      return {};
    }

    return {
      fillColor: properties['pups'] < 5 ? '#800' : '#ff7',
    };
  };

  getWmsLayer(
    namespace: string,
    namespaceTitle: string,
    layerName: string,
    layerTitle: string,
    index: number,
    mapId: string,
    layerInfo: LayerInfo
  ) {
    const wmsLayer = Leaflet.tileLayer.betterWms(`${this.geoServerUrl}/wms?`, {
      layers: `${namespace}:${layerName}`,
      mapId,
      service: 'WMS',
      request: 'GetMap',
      version: '1.1.1',
      // srs: 'EPSG:4326',
      // SRS: 'EPSG:4326',
      // crs: Leaflet.CRS.EPSG3857,
      format: 'image/png',
      pane: layerName,
      transparent: true,
      exceptions: 'application/vnd.ogc.se_inimage',
    });

    // const temporalWmsLayer = Leaflet.timeDimension.layer.wms(wmsLayer);

    const lineLayer = new LayerItem({
      name: layerTitle,
      pane: layerName,
      layerType: LayerTypeEnum.TemporalLayer,
      layerStyles: new LayerStyle({ zIndex: index }),
      nativeLayer: wmsLayer,
      namespaceTitle: namespaceTitle,
      namespace: namespace,
      layerInfo,
    });

    return lineLayer;
  }

  getHeatmapLayer(
    namespace: string,
    namespaceTitle: string,
    layerName: string,
    layerTitle: string,
    index: number,
    mapId: string,
    layerInfo: LayerInfo
  ) {
    const nodenonTiled = Leaflet.nonTiledLayer.wms(`${this.geoServerUrl}/wms?`, {
      layers: `${namespace}:${layerName}`,
      service: 'WMS',
      request: 'GetMap',
      version: '1.1.1',
      mapId,
      format: 'image/png',
      pane: layerName,
      transparent: true,
      exceptions: 'application/vnd.ogc.se_inimage',
    });

    const nonTiledLayerItem = new LayerItem({
      name: layerTitle,
      layerType: LayerTypeEnum.NonTiledLayer,
      pane: layerName,
      layerStyles: new LayerStyle({ zIndex: index }),
      nativeLayer: nodenonTiled,
      namespaceTitle: namespaceTitle,
      namespace: namespace,
      layerInfo,
    });

    return nonTiledLayerItem;
  }

  private get geoServerUrl(): string {
    return 'https://map.platform.simulator.wlm.one/geoserver';
    //////////////return this._tcSettingsService.geoServer.url;
  }
}
